import React, { PropTypes, Component } from 'react';
import { connectToStores } from 'fluxible/addons';
import OffersComponent from '../components/Offers';

class OffersPage extends Component {
  static propTypes = {
    offers: PropTypes.array.isRequired,
    entity: PropTypes.object.isRequired
  }

  static defaultProps = {
    offers: [],
    entity: {}
  }

  render() {
    const offers = this.props.offers;
    const entity = this.props.entity;
    //console.log(results);
    return (
      <OffersComponent offers={ offers } entity={ entity } />
      );
  }
}

OffersPage = connectToStores(OffersPage, ['OffersStore'], (stores, props) => {
  return {
    offers: stores.OffersStore.get().offers,
    entity: stores.OffersStore.get().entity
  };
});

export default OffersPage;



// WEBPACK FOOTER //
// ./src/pages/OffersPage.js